export default __webpack_public_path__ + "8f17236f3d3bed50da8f3c4dedb5100b.png";